import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LoginUserPage } from './login-user.page';
import { CounterDirective } from 'src/app/directives/counter.directive';
import { CounterDirectiveModule } from 'src/app/directives/counter.directive.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    CounterDirectiveModule
  ],
  declarations: [LoginUserPage],

  // declarations: [LoginUserPage]
})
export class LoginUserPageModule { }
